<template>
  <div class="container-visit-schedule">
    <template>
      <div class="spinner-load" v-if="spinner">
        <div class="spinner-border spinner-border-sm decision-spinner" role="status"></div>
      </div>
    </template>
    <div class="container-visit-schedule-box" v-if="usersList.length || usersListAll.length">
      <div class="schedule-time" v-if="false">
        <ul>
          <li v-for="(time, index) in pageTimeGround" :key="index">
            <span>{{time}}</span>
          </li>
        </ul>
      </div>
      <div class="visitsSchedule" v-if="!spinner">
      <span class="visitsSchedule-checkbox">
        <d-checkbox inline toggle v-model="changeList">
          Tylko specjaliści z dostępnymi wizytami
        </d-checkbox>
      </span>
        <div class="visits__schedule" v-if="changeList  && !usersList.length">
          <d-alert
            class="visits__schedule_empty"
            show
            :theme="'info'">
            Brak dostępnych wizyt na dzień: <b>{{currentDay}}</b>
          </d-alert>
        </div>
        <div class="visits__schedule" v-if="changeList && usersList.length">
          <div class="visits__schedule_time">
            <ul>
              <li
                :style="[listStyleHeight, !changeList ? listStyleWidthAll : listStyleWidth]"
                v-for="(time, index) in pageTimeGround"
                :key="index">
                <div class="visits__schedule_time_clock"><p>{{time}}</p><span></span></div>
                <p :style="[listStyleHeight, !changeList ? listStyleWidthAll : listStyleWidth]"></p>
              </li>
            </ul>
          </div>
          <div v-if="usersList.length" class="visits__schedule_visit">
            <ul class="visits__schedule_visit_content">
              <li
                v-for="(user, index) in usersList"
                :style="'min-width: ' + (((user.name.length / 8) * 7) + 'rem')"
                class="visits__schedule_visit_content_list"
                :key="index">
                <p>{{user.name}}<span></span></p>
                <ul
                  class="visits__schedule_visit_content_list_items"
                  :style="listStyleHeight">
                  <li
                    class="visits__schedule_visit_content_list_items_item"
                    v-for="(detail, indexDetail) in taskDetail[index]" :key="indexDetail"
                    :style="[detail.styleObj, detail.styleObj ?
                (detail.styleObj.width = (((user.name.length / 10) * 8.5)) + ((user.name.length < 20) ? (-0.5) : (user.name.length < 10 )) + 'rem') : '']"
                    @click="showDetail(detail, user.visits[indexDetail][indexDetail])">
                    <p>{{detail.dateStart ? detail.dateStart.slice(11, 16) : ''}} - {{detail.dateEnd ? detail.dateEnd.slice(11, 16) : ''}} <i class="material-icons" v-d-tooltip="'Pacjent: ' + patients[index]">person_search</i></p>
                  </li>
                </ul>
                <ul
                  class="visits__schedule_visit_content_list_items"
                  style="height: auto"
                  v-for="(detailFree, indexDetailFree) in taskDetailFree[index]" :key="indexDetailFree">
                  <li
                    class="visits__schedule_visit_content_list_items_item detailFree_item"
                    v-for="(free, indexDetail) in detailFree" :key="indexDetail"
                    :style="[(detailFree[indexDetail] ? detailFree[indexDetail].styleObj : ''), detailFree[indexDetail] ?
          (detailFree[indexDetail].styleObj.width = (((user.name.length / 10) * 8.5)) + ((user.name.length < 20) ? (-0.5) : (user.name.length < 10 )) + 'rem') : '']">
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div class="visits__schedule" v-if="!changeList">
          <div class="visits__schedule_time">
            <ul>
              <li :style="[listStyleHeight, !changeList ? listStyleWidthAll : listStyleWidth]" v-for="(time, index) in pageTimeGround" :key="index">
                <div class="visits__schedule_time_clock"><p>{{time}}</p><span></span></div>
                <p :style="[listStyleHeight, !changeList ? listStyleWidthAll : listStyleWidth]"></p>
              </li>
            </ul>
          </div>
          <div class="visits__schedule_visit">
            <ul class="visits__schedule_visit_content">
              <li
                v-for="(user, index) in usersListAll"
                :style="'min-width: ' + (((user.name.length / 8) * 7) + 'rem')"
                class="visits__schedule_visit_content_list"
                :key="index">
                <p>{{user.name}}<span></span></p>
                <ul
                  class="visits__schedule_visit_content_list_items"
                  :style="listStyleHeight">
                  <li
                    class="visits__schedule_visit_content_list_items_item"
                    v-if="detail.dateStart && (currentDay === detail.dateStart.slice(0, 10))"
                    v-for="(detail, indexDetail) in taskDetailAll[index]" :key="indexDetail"
                    :style="[detail.styleObj, detail.styleObj ?
            (detail.styleObj.width = (((user.name.length / 10) * 8.5)) + ((user.name.length < 20) ? (-0.5) : (user.name.length < 10 )) + 'rem') : '']"
                    @click="showDetail(detail, user.visits[indexDetail][indexDetail])">
                    <p>{{detail.dateStart ? detail.dateStart.slice(11, 16) : ''}} - {{detail.dateEnd ? detail.dateEnd.slice(11, 16) : ''}} <i class="material-icons">person_search</i></p>
                  </li>
                </ul>
                <ul
                  style="height: auto"
                  class="visits__schedule_visit_content_list_items"
                  v-for="(detailFree, indexDetailFree) in taskDetailAllFree[index]" :key="indexDetailFree">
                  <li
                    class="visits__schedule_visit_content_list_items_item detailFree_item"
                    v-if="detailFree[indexDetail] && free"
                    v-for="(free, indexDetail) in detailFree" :key="indexDetail"
                    :style="[(detailFree[indexDetail] ? detailFree[indexDetail].styleObj : ''), detailFree[indexDetail] ?
          (detailFree[indexDetail].styleObj.width = (((user.name.length / 10) * 8.5)) + ((user.name.length < 20) ? (-0.5) : (user.name.length < 10 )) + 'rem') : '']">
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <visits-popup
          v-if="visit[0]"
          :key="keyPopup"
          :close-modal="handleClose"
          :show-modal="showModal"
          :visit="visit[0]"
          :get-day="dayName"
          :reload-data="refresh"
          :my-account="myAccount"/>
      </div>
    </div>
    <d-alert
      v-if="!usersList.length || !usersListAll.length"
      show
      class="mt-3 text-center emptyDay"
      :theme="'info'">
      Brak dostępnych specjalistów
    </d-alert>
  </div>
</template>
<script>
import VisitsPopup from './VisitsPopup';
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'VisitsSchedule',
  components: { VisitsPopup },
  data() {
    return {
      pageTimeGround: [],
      visit: [],
      spinner: true,
      showModal: false,
      changeList: false,
      showModalDetail: {
        dateStart: '',
        dateEnd: '',
        patient: '',
        medical: '',
        user: '',
        visit_id: '',
        styleObj: {
          backgroundColor: '',
          width: ''
        },
        detail: ''
      },
      listStyleHeight: {
        height: '900px'
      },
      listStyleWidth: {
        width: '100%'
      },
      listStyleWidthAll: {
        width: ''
      },
      contentStyleWidth: {
        width: '100%'
      }
    }
  },
  props: {
    endpointInstitutions: {
      type: [Array, Object]
    },
    endpointPatients: {
      type: [Array, Object]
    },
    endpointServices: {
      type: [Array, Object]
    },
    endpointUsers: {
      type: [Array, Object]
    },
    dayName: {
      type: String,
      required: true,
    },
    currentDay: {
      type: String,
      required: true,
    },
    myAccount: {
      type: [Array, Object],
      required: true
    },
    refresh: {
      type: Function,
      required: true,
    },
    spinnerSchedule: {
      type: Boolean,
      required: true,
    },
    keyPopup: {
      type: Number,
      required: true,
    },
    timeGround: {
      type: Array,
      default() {
        return []
      }
    },
    patients: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    patientsAll: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    usersList: {
      type: Array,
      default() {
        return []
      }
    },
    usersListAll: {
      type: Array,
      default() {
        return []
      }
    },
    taskDetail: {
      type: Array,
      default() {
        return []
      }
    },
    taskDetailAll: {
      type: Array,
      default() {
        return []
      }
    },
    taskDetailAllFree: {
      type: Array,
      default() {
        return []
      }
    },
    taskDetailFree: {
      type: Array,
      default() {
        return []
      }
    },
    colorEmpty: {
      type: Array,
      default() {
        return [
          '#cfcfcf',
        ]
      }
    },
    color: {
      type: Array,
      default() {
        return [
          '#29A5D8',
          '#36C2DB',
          '#33D4DB',
          '#31DBC8',
          '#1adba2',
          '#17c671',
          '#28C639',
          '#04C617',
          '#50c61c',
          '#89c626',
          '#abc62e',
          '#c4c620',
          '#c6a415',
          '#c68a16',
          '#c6681a',
          '#c64215',
          '#c61318',
          '#c62054',
          '#c62c89',
          '#c628b3',
        ]
      }
    }
  },
  watch: {
    timeGround(value) {
      if (value.length) {
        this.spinner = true;
        this.pageTimeGround = this.initTimeGround(value);
        this.getValue();
        setTimeout(() => {
          this.spinner = false
        }, 500);
      }
    },
    taskDetail() {
      this.getValue();
    },
    currentDay() {
      this.calculateTheWidth();
    }
  },
  mounted() {
    this.listStyleHeight.height = ((this.pageTimeGround.length - 1) * 100) + 'px';
    if (this.usersList) {
      setTimeout(() => {
        this.calculateTheWidth();
      }, 600)
    }
  },
  methods: {
    calculateTheWidth () {
      this.listStyleWidth.width = (this.usersList.length * 50) + '%';
      let sumAll = 0;
      let sum = 0;
      for (let i = 0; i < this.usersListAll.length; i++) {
        sumAll += this.usersListAll[i].name.length;
        this.listStyleWidthAll.width = (sumAll * 14) + 'px';
      }
      for (let i = 0; i < this.usersList.length; i++) {
        sum += this.usersList[i].name.length;
        this.listStyleWidth.width = (sum * 13.85) + 'px';
      }
    },
    getValue() {
      if (this.timeGround) {
        this.pageTimeGround = this.initTimeGround(this.timeGround);
        let maxTime = this.pageTimeGround[this.pageTimeGround.length - 1];
        let minTime = this.pageTimeGround[0];
        let maxMin = (maxTime.split(':')[0] * 60) + (maxTime.split(':')[1] * 1);
        let minMin = (minTime.split(':')[0] * 60) + (minTime.split(':')[1] * 1);
        for (let i = 0; i < this.taskDetail.length; i++) {
          if (this.taskDetail[i]) {
            for (let j = 0; j < this.taskDetail[i].length; j++) {
              let startMin = (this.taskDetail[i][j].dateStart.slice(11, 16).split(':')[0] * 60) + (this.taskDetail[i][j].dateStart.slice(11, 16).split(':')[1] * 1);
              let endMin = (this.taskDetail[i][j].dateEnd.slice(11, 16).split(':')[0] * 60) + (this.taskDetail[i][j].dateEnd.slice(11, 16).split(':')[1] * 1);
              if (startMin < minMin || endMin > maxMin) {
                this.taskDetail[i].splice(j, 1);
              }
              let difMin = endMin - startMin;
              this.taskDetail[i][j].styleObj = {
                height: (((difMin * 100) / 65) + 5) + 'px',
                top: (((((startMin - ((this.pageTimeGround[0].split(':')[0] * 60) + (this.pageTimeGround[0].split(':')[1] * 1))) * 100) / 60) + 50.5) - 5) + 'px',
                backgroundColor: this.color[Math.floor(Math.random() * this.color.length)],
                width: ''
              };
            }
          }
        }
        for (let i = 0; i < this.taskDetailAll.length; i++) {
          if (this.taskDetailAll[i]) {
            if (this.taskDetailAll[i].length) {
              for (let j = 0; j < this.taskDetailAll[i].length; j++) {
                if (this.taskDetailAll[i][j].dateStart) {
                  let startMin = (this.taskDetailAll[i][j].dateStart.slice(11, 16).split(':')[0] * 60) + (this.taskDetailAll[i][j].dateStart.slice(11, 16).split(':')[1] * 1);
                  let endMin = (this.taskDetailAll[i][j].dateEnd.slice(11, 16).split(':')[0] * 60) + (this.taskDetailAll[i][j].dateEnd.slice(11, 16).split(':')[1] * 1);
                  if (startMin < minMin || endMin > maxMin) {
                    this.taskDetailAll[i].splice(j, 1);
                  }
                  let difMin = endMin - startMin;
                  this.taskDetailAll[i][j].styleObj = {
                    height: (((difMin * 100) / 65) + 5) + 'px',
                    top: (((((startMin - ((this.pageTimeGround[0].split(':')[0] * 60) + (this.pageTimeGround[0].split(':')[1] * 1))) * 100) / 60) + 50) - 5) + 'px',
                    backgroundColor: this.color[Math.floor(Math.random() * this.color.length)],
                    width: ''
                  };
                }
              }
            }
          }
        }
        for (let i = 0; i < this.taskDetailAllFree.length; i++) {
          if (this.taskDetailAllFree[i]) {
            for (let j = 0; j < this.taskDetailAllFree[i].free_hours.length; j++) {
              this.taskDetailAllFree[i].free_hours[j].styleObj = {
                height: this.taskDetailAllFree[i].free_hours[j].height + 'px',
                top: this.taskDetailAllFree[i].free_hours[j].top + 'px',
                backgroundColor: this.colorEmpty[Math.floor(Math.random() * this.colorEmpty.length)],
                width: ''
              };
            }
          }
        }
        for (let i = 0; i < this.taskDetailFree.length; i++) {
          if (this.taskDetailFree[i]) {
            for (let j = 0; j < this.taskDetailFree[i].free_hours.length; j++) {
              this.taskDetailFree[i].free_hours[j].styleObj = {
                height: this.taskDetailFree[i].free_hours[j].height + 'px',
                top: this.taskDetailFree[i].free_hours[j].top + 'px',
                backgroundColor: this.colorEmpty[Math.floor(Math.random() * this.colorEmpty.length)],
                width: ''
              };
            }
          }
        }
      }
    },
    getVisit (id) {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/visits/list?ignore_institutions_filters=1',
        outputKey: 'visit',
        pagination: false,
        params: {
          pagination: false,
          visit_id: id,
        },
        successAction: () => {
          setTimeout(() => {
            this.showModalVisit = true
          }, 500)
        }
      });
    },
    showDetail(obj, visit) {
      this.getVisit(visit.visitsId);
      setTimeout(() => {
        this.showModalDetail = obj;
        this.showModal = true;
      }, 200);
    },
    handleClose() {
      this.showModalDetail = '';
      this.showModal = false;
    },
    initTimeGround(value) {
      if (value && value.length === 2) {
        let startTime = value[0].split(':')[0] * 1;
        let endTime = value[1].split(':')[0] * 1;
        value = [];
        for (let i = startTime; i <= endTime; i++) {
          let hour = i < 10 ? '0' + i : '' + i;
          value.push(hour + ':00');
        }
      } else {
        value = [
          '08:00',
          '09:00',
          '10:00',
          '11:00',
          '12:00',
          '13:00',
          '14:00',
          '15:00',
          '16:00',
          '17:00',
          '18:00',
          '19:00',
          '20:00',
          '21:00',
        ]
      }
      return value;
    }
  }
}
</script>
<style lang="scss">
@import '../../assets/scss/visits-schedule.scss';
</style>
